export default "__VITE_ASSET__abffd094__"